export const FORM_QUESTION_ERRORED = 'FORM_QUESTION_ERRORED';
export const PREQUAL_QUESTION_ERRORED = 'PREQUAL_QUESTION_ERRORED';

function erroredQuestion({ id, mode, isForm, customError }) {
  return {
    type: isForm ? FORM_QUESTION_ERRORED : PREQUAL_QUESTION_ERRORED,
    id,
    isAnswered: false,
    hasError: true,
    answer: '',
    customError,
    mode
  };
}

export function questionErrored(question) {
  return dispatch => dispatch(erroredQuestion(question));
}
